import { useFlexRow } from '../hooks/useFlexRow';
import { FlexRowContent } from './FlexRowContent';

export function FlexRow({ children }: any) {
	const { blockClass, componentId } = useFlexRow();

	const renderClass = () => {
		return blockClass && `vtex-flex-layout-0-x-flexRow--${blockClass} flexRow--${blockClass}`;
	};

	return (
		<div data-selection={componentId} className={`vtex-flex-layout-0-x-flexRow flexRow ${renderClass()}`}>
			<FlexRowContent>{children}</FlexRowContent>
		</div>
	);
}
